import Schema from "AppReact/schema";
import {
  videoTraining,
  trainingVideoModalDefaultValue,
} from "modals/trainingVideoModal/types";
import { uploadingTracker, uploadingTrackerDefaultValue } from "../../apps/management/trainingVideosApp/types";

export default {
  linkCopied: Schema("boolean", "primitive", { defaultValue: false }),
  training: Schema(videoTraining, "object", {
    defaultValue: { ...trainingVideoModalDefaultValue },
  }),
  uploadingTracker: Schema(uploadingTracker, "object", {
    defaultValue: { ...uploadingTrackerDefaultValue },
  }),
};
